import React, { useContext, useState, useEffect } from "react";
import SearchBar from "../../components/SearchBar";
import DataContext from "../../contexts/data";
import { useTranslation } from "react-i18next";
import Product from "../../components/Product";
import { Container, Col, Row } from "react-bootstrap";
import Empty from "../../components/Empty";

const Index = (props) => {
  const { t } = useTranslation();
  const { products, baskets, loading, prodType, loadMore, setProdType, setLoadMore } = useContext(DataContext);
  const [prods, setProds] = useState([]);
  const [basks, setBasks] = useState([]);

  useEffect(() => {
    setProds(products);
  }, [products]);

  useEffect(() => {
    setBasks(baskets);
  }, [baskets]);

  //filter results
  const _handleFilter = (search, category, sort) => {
    if (prodType === 1) {
      let list = products.filter((product) =>
        t("language") === "en"
          ? product.name.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
          : product.nameEn.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
      );

      if (category !== "All") {
        list = list.filter((product) => product.category === `${category}`);
      }

      if (sort !== "All") {
        list.sort((a, b) => (sort === "1" ? b.price - a.price : a.price - b.price));
      }

      setProds(list);
    } else {
      let list = baskets.filter((basket) =>
        basket.name.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
      );

      if (sort !== "All") {
        list.sort((a, b) => (sort === "1" ? b.price - a.price : a.price - b.price));
      }

      setBasks(list);
    }
  };

  const renderItems = () => {
    if (loading) {
      return (
        <Col lg={12} className="mt-5 text-center">
          <div className="spinner-grow text-success mt-5" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </Col>
      );
    }

    if (prodType === 1) {
      if (prods.length === 0) return <Empty text={t("empty")} />;

      return (
        <>
          <Col sm={12} className="mt-5 grid-container">
            {prods.map((product, index) => (
              <Product
                key={index}
                item={product}
                onClick={() => props.history.push({ pathname: `/product/details/${product.id}` })}
              />
            ))}
          </Col>
          <Col sm={12} className="mt-5  text-center">
            {loadMore ? (
              <div className="spinner-grow text-success mt-5" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <button className="btn btn-success w-100" onClick={() => setLoadMore((prev) => true)}>
                {t("loadmore")}
              </button>
            )}
          </Col>
        </>
      );
    }

    if (prodType === 2) {
      if (basks.length === 0) return <Empty text={t("empty")} />;

      return (
        <Col sm={12} className="mt-5 grid-container">
          {basks.map((product, index) => (
            <Product
              key={index}
              item={product}
              onClick={() => props.history.push({ pathname: `/basket/details/${product.id}` })}
            />
          ))}
        </Col>
      );
    }
  };

  return (
    <main className="mt-5 mt-lg-0">
      <Container>
        <Row>
          <SearchBar onChange={_handleFilter} prodType={prodType} />

          <Col lg={12} className="d-flex justify-content-around align-items-center mt-3">
            <div
              className="rounded p-2"
              style={{
                backgroundColor: prodType === 1 ? "rgba(15, 188, 73, 0.1)" : "",
                color: prodType === 1 ? "#2E9913" : "#000",
                cursor: "pointer",
              }}
              onClick={() => setProdType(1)}
            >
              <strong>{t("products")}</strong>
            </div>

            <div
              className="rounded p-2"
              style={{
                backgroundColor: prodType === 2 ? "rgba(15, 188, 73, 0.1)" : "",
                color: prodType === 2 ? "#2E9913" : "#000",
                cursor: "pointer",
              }}
              onClick={() => setProdType(2)}
            >
              <strong>{t("baskets")}</strong>
            </div>
          </Col>
        </Row>

        <hr className="text-muted" />

        <Row> {renderItems()} </Row>
      </Container>
    </main>
  );
};

export default Index;
